import { Container } from "@volumental/common";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";
import { useViewStore } from "../../store";
import { CurrentView } from "../../types/types";
import step1 from "@volumental/assets/images/Hybrid/introMap1.png";
import step2 from "@volumental/assets/images/Hybrid/introMap2.png";
import { Button, Content, Headline } from "@volumental/common";
import { Header } from "../../components/accessible-components";
import { JourneyListItem } from "./journey-list-item";

interface StepIntroViewProps {
  onClose: () => void;
  onBack: () => void;
}

export function StepIntroView({ onClose, onBack }: StepIntroViewProps): JSX.Element {
  const { t } = useTranslation();
  const { setCurrentView } = useViewStore((store) => store);

  const onNext = (): void => {
    setCurrentView(CurrentView.SizePicker);
  };

  return (
    <Container>
      <Header close={onClose} back={onBack} />
      <Content disableGutters disableScrollbar>
        <div className="px-6">
          <Headline className="my-8">{t("hybrid.journeyMap.title")}</Headline>
          <div className="w-full flex justify-start self-center py-1.75">
            <JourneyListItem
              item={{
                alt: t("hybrid.journeyMap.step1.alt"),
                imgSrc: step1,
                title: t("hybrid.journeyMap.step1.title"),
                description: t("hybrid.journeyMap.step1.description"),
              }}
            />
          </div>
          <div className="w-full flex justify-start self-center py-1.75">
            <JourneyListItem
              item={{
                alt: t("hybrid.journeyMap.step2.alt"),
                imgSrc: step2,
                title: t("hybrid.journeyMap.step2.title"),
                description: t("hybrid.journeyMap.step2.description"),
              }}
            />
          </div>
        </div>
      </Content>
      <div className="flex flex-col items-center mx-6 my-7.5">
        <Button loading={false} type="submit" onClick={onNext}>
          {t("button.continue")}
        </Button>
      </div>
    </Container>
  );
}
